import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { getAllHistorial } from '../services/tramiteService';
import { useAlert } from '../hooks/useAlert';

export const useHistorial = ({ tramite }) => {
  const [idTramite, setIdTramite] = useState(tramite.id || 0);
  const [historial, setHistorial] = useState([]);
  const [loading, setLoading] = useState(false);

  const { errorAlert } = useAlert();

  useEffect(() => {
    setLoading(true);
    getAllHistorial(idTramite).then(historial => {
      setHistorial(historial.map(h => ({
        key: _.uniqueId("historial"),
        usuario: h.email,
        nombre: h.name,
        fecha: h.created_at,
        detalle: h.details
      })));
    }).catch(err => {
      errorAlert({ exception: err });
    }).finally(() => {
      setLoading(false);
    });

  }, []);

  return {
    historial,
    loading
  }
}